import { gql, useMutation, useQuery } from '@apollo/client';
import { useCallback } from 'react';

const MARK_MODAL_AS_SEEN = gql`
  mutation MarkModalAsSeen ($input: ModalTrackingMarkAsSeenOrShouldDisplayInputType!) {
    markModalAsSeen (input: $input)
  }
`;

const SHOULD_DISPLAY_MODAL = gql`
  query ShouldDisplayModal ($input: ModalTrackingMarkAsSeenOrShouldDisplayInputType!) {
    shouldDisplayModal (input: $input) {
      shouldExecute
      title
      text
    }
  }
`;

interface MarkModalAsSeenOutput {
  markModalAsSeen: boolean,
}

export interface ShouldDisplayData {
  shouldExecute: boolean,
  title?: string,
  text?: string[],
}

interface ShouldDisplayModalOutput {
  shouldDisplayModal: ShouldDisplayData,
}

export function useMarkModalAsSeen() {
  const [mark] = useMutation<MarkModalAsSeenOutput>(MARK_MODAL_AS_SEEN);

  const markModalAsSeen = useCallback(async () => {
    await mark({
      variables: {
        input: {},
      },
    });
  }, [mark]);

  return {
    markModalAsSeen,
  };
}

export function useShouldDisplayModal() {
  return useQuery<ShouldDisplayModalOutput>(SHOULD_DISPLAY_MODAL, {
    variables: {
      input: {},
    },
  });
}
